import { DatePicker } from "antd";
import dayjs from "dayjs";
 
const { RangePicker } = DatePicker;
 
interface DateRangeFilterProps {
  dateRange: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null;
  setDateRange: (val: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => void;
  label?: string;
}
 
const DateFilter = ({
  dateRange,
  setDateRange,
  label = "Date Range:",
}: DateRangeFilterProps) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <strong>{label}</strong>
      <RangePicker
        value={dateRange}
        onChange={(val) => setDateRange(val)}
        placeholder={["Start Date", "End Date"]}
      />
    </div>
  );
};
 
export default DateFilter;
 